import codes from '@/codes'
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { userWsfinder as wsfinder } from '@/service/api/wsfinder'

export default {
  components: {
    cSwitch,
  },
	data : () => { return { lock : false, codes : codes, model : { } } },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel: function() { this.$router.replace({ name: 'wsfinder_upattern', params: { id: this.model.id}}); },
    list: function() { this.$router.push({ name: 'wsfinder_upattern'}); },
    async save() {
      if(!(this.model.type)) { return this.$toastr.e('Type is Require.'); }
      if(!(this.model.ext)) { return this.$toastr.e('Ext is Require.'); }
      if(!(this.model.category)) { return this.$toastr.e('Category is Require.'); }
      if(!(this.model.code || '').trim()) { return this.$toastr.e('Code is Require.'); }

      if(!this.regex_valid(this.model.code)) { return this.$toastr.e("No vaild expression"); }

      try {
        let check_id = '';
        check_id = this.model.id ? `${await wsfinder.updateUser(this.model)}` : `${await wsfinder.insertUser(this.model)}`

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved.', this.$route.name);this.cancel();
        } else {
          this.$toastr.s('Save', 'failed'); this.list()
        }
         this.$emit('refresh');
        return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.edit.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await wsfinder.detailUser({id : id});
          this.model = Object.assign({}, this.model, rs.body);
        } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText),this.cancel(); }
      }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params.id); console.log(`from : ${from}`); this.$on('refresh', this.refresh()) } },
  created: function() { console.log('pattern.edit.vue', 'created'); },
  destroyed: function() { console.log('pattern.edit.vue', 'destroyed'); },
  mounted: function() {
    console.log('pattern.edit.vue', 'mounted');
    this.get(this.$route.params.id);
  }
}